import { useQuery } from '@apollo/client';
import { GET_PRODUCTS_QUERY, ProductsQueryResult } from '../services/products';

// The product catalog changes only on deploys; legacy fetched it once at
// dashboard/settings mount, so read through the cache.
export const useProducts = () => {
  const { data, loading } = useQuery<ProductsQueryResult>(GET_PRODUCTS_QUERY, {
    fetchPolicy: 'cache-first',
  });

  return { products: data?.products, loading };
};
